<template>
  <modal 
    name="free-version-notice-modal" 
    :pivotY="0.2"
    :height="'auto'"
    width="90%" :maxWidth="550" :adaptive="true">
    
    <div class="border-b p-4 overflow-hidden">
      <div class="text-xl font-light float-left">
        Welcome back tp {{ getAppName }} {{ this.$store.state.brokerModule.broker.first_name }}.
      </div>

      <div class="float-right">
        <a href="#"
          v-on:click.prevent="$modal.hide('free-version-notice-modal')"
          class="text-grey hover:text-grey-darker">
          <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
            <use xlink:href="/img/feather-sprite.svg#x"/>
          </svg>
        </a>
      </div>
    </div>
    
    <div class="p-4">

      <div class="text-base leading-normal">
        Hi {{ this.$store.state.brokerModule.broker.first_name }},
      </div>

      <div class="mt-3 text-base leading-normal">
        Welcome back to {{ getAppName }} and thanks for checking out the free version of {{ getAppName }}.
        This is a simple and fast CRM where you can manage your clients' details.
      </div>

      <div class="mt-3 text-base leading-normal">
        It also includes our new 
        <router-link
        :to="{
          name  : 'broker-lead-capture',
          params: {
            brokerId : $route.params.brokerId
          }
        }"
        tag="a"
        class="font-semibold text-blue-600 underline">Lead Capture Form</router-link>
        which you can link from your own website or Facebook page (or anywhere!).
        Your potential clients who fill out them form will be automatically added
        to your {{ getAppName }} account.
      </div>

      <div class="mt-3 text-base leading-normal">
        You can access your 
        
        <router-link
        :to="{
          name  : 'broker-lead-capture',
          params: {
            brokerId : $route.params.brokerId
          }
        }"
        tag="a"
        class="font-semibold text-blue-600 underline">Lead Capture Form</router-link>

        by going to <span class="text-green-600">My Settings</span> and clicking on 
        <span class="text-green-600">Lead Capture Form</span>  in the menu.
      </div>

      <div class="mt-3 text-base leading-normal">
        If you have any problems or didn't receive the email, please 
        <a href="mailto:info@brokerpad.com.au" class="text-blue-600 underline font-semibold">let us know</a> and we will look into this immediately.
      </div>

      <div class="mt-8 text-left">
        <SubmitButton label="Got it!" v-bind:onClick="submit" v-bind:loading="loading"></SubmitButton>
      </div>

    </div>
  </modal>
</template>

<script>
  import SubmitButton from '@/shared/components/form/SubmitButton'

  export default {

    components : {
      SubmitButton
    },

    data() {
      return {
        domain    : null,
        createWhat: null,
        loading   : false
      }
    },

    methods : {
      submit() {
        if(this.$route.params.showConfirmRegistration != null) {
          this.loading = true
          this.$modal.hide('free-version-notice-modal')
          this.$router.push({
            name: 'broker-home', 
          })
        }

        else {
          this.$modal.hide('free-version-notice-modal')
        }
      }
    }
  }
</script>